import { Box, Grid, makeStyles, Theme } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { GeoAutoCompletion } from "components/GeoAutoCompletion";
import useText from "constants/text";
import { InationalTransportPoint, ItemAtPoint, NewRequestQuoteContext } from "contexts/RequestQuoteContext";
import { Address, EActionType } from "generated/graphql";
import React, { useContext, useEffect, useState } from "react";
import ArticleToPickAtPoint from "./ArticleToPickAtPoint";
import { DeletePoint } from "./MainStyles";
import { isFieldWithValue } from "./utils";
import { useCallback } from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  Box: {
    border: "1px solid #399ebf",
    height: "auto",
    width: "70%",
    padding: "10px 20px 20px 20px",
    borderRadius: "5px",
    marginTop: "20px",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      padding: "28px -1 17px 12px",
    },
  },
  delete: {
    display: "flex",
    flexDirection: "row-reverse",
    marginBottom: "8px",
    [theme.breakpoints.down("xs")]: {
      position: "relative",
    },
  },
}));
interface IDestinationPoint {
  fieldError?: boolean;
  possiblePointsTopick: InationalTransportPoint[];
  point?: any;
  positionPoint: number;
  onChangePoint: (point: InationalTransportPoint, positionPoint: number) => void;
  onChangePointDelivery: (point: InationalTransportPoint, positionPoint: number, isForDeliver?: boolean) => void;
  onDeletePoint: (positionPoint: number) => void;
}

export default function DestinationPoint({
  possiblePointsTopick,
  point,
  positionPoint,
  onChangePoint,
  onChangePointDelivery,
  onDeletePoint,
}: IDestinationPoint) {
  const { text } = useText();
  const [address, setAddress] = useState<Address>(null);
  const {fieldError, setFieldError } = useContext(NewRequestQuoteContext);
  const styles = useStyles();
  const handleSetArticlesToPick = (articlesTopick: ItemAtPoint[]) => {
    onChangePoint(
      { ...point, itemsToPick: articlesTopick, address: address || point?.address, action: EActionType.Pickup },
      positionPoint
    );
  };

  const handleSetArticlesToDelivery = (articlesToDeliver: ItemAtPoint[]) => {
    onChangePointDelivery(
      {
        ...point,
        itemsToDelivered: articlesToDeliver,
        address: address || point?.address,
        action: EActionType.Delivery,
      },
      positionPoint
    );
  };

  const extractItemCheckedFromPossiblePointsToPick = () => possiblePointsTopick?.flatMap((p) => p.itemsToPick);

  const extractArticleFromPossiblePointsToPick = () =>
    possiblePointsTopick?.flatMap((p) => p.itemsToPick?.map((i) => i?.counter > 0 && i?.product));

    const checkPlaceId = point?.address?.place_id === null || undefined;
    useCallback(()=>{
      if(address || point?.address === null){
        setFieldError(true)
      }
      setFieldError(false)

    }, [address, point?.address])

  return (
    <>
      <Box className={styles.Box}>
        <Grid className={styles.delete}>
          <DeletePoint onClick={() => onDeletePoint(positionPoint)}>
            <CloseIcon />
          </DeletePoint>
        </Grid>
        <Grid item xs={12}>
          <GeoAutoCompletion
            customLabel={text.all.destination}
            placeholder={text.all.where_to_go}
            address={address || point?.address}
            onChange={(values) => {
              onChangePoint({ ...point, address: values }, positionPoint);
            }}
            error={fieldError && checkPlaceId}
            helperText={
              fieldError && checkPlaceId ? text.all.this_field_is_required : ""
            }
            locationIcon
            required
          />
        </Grid>
        <Grid item xs={12} >
          <ArticleToPickAtPoint
            articlesTopick={point?.itemsToPick}
            onChange={handleSetArticlesToPick}
            positionPoint={positionPoint}
            isStop
            possibleArticlesToDeliver={extractArticleFromPossiblePointsToPick()}
            productsChecked={extractItemCheckedFromPossiblePointsToPick()}
            onChangeDeliver={handleSetArticlesToDelivery}
            onChangeToPick={handleSetArticlesToPick}
            articlesToDeliver={point?.itemsToDelivered}
            point={point}
          />
        </Grid>
      </Box>
    </>
  );
}
